import OrgLink from "../../components/Layout/OrganizersLink";

export default function HEALRepair({ children }) {
  return (
    <>
      <p>
        HEAL explores the concept of healing and mending emotional memories through the design,
        restoration, and transformation of broken objects.
      </p>
      <p>
        What does “retail therapy” do for us? And yet, why do we keep some things even after they
        have lost their form and function?
      </p>
      <p>
        As throwaway culture, mental health and wellbeing have been drawing increasing attention,
        HEAL: Repair+ delves into narratives surrounding brokenness and broken items and how the act
        of repair can provide an alternative path to healing.
      </p>
      <p>
        An open call was made via social media and community partner outreach to submit broken,
        spoilt, and faulty objects that were meaningful or precious. Eight objects were chosen and
        paired with eight designers who were invited to restore the submitted objects. Through
        discussion and collaboration between the owners and designers, they explored the memories
        associated with their objects and pushed the boundaries of creative restoration to create
        new objects and new memories.
      </p>
      <p>
        HEAL: Repair+ takes collaboration in a new direction as it evolves from Hans Tan Studio's
        successful exhibitions of R for Repair (2021) that highlighted global waste with ingenuity
        to give broken and discarded items a new lease of life and R for Repair: London x Singapore
        (2022), which added further elements of cultural exchange and connected humans from across
        the globe.
      </p>
      {children}
      <div className="credits">
        HEAL: Repair+ is presented at 42 Waterloo Street in partnership with the Arts Resource Hub,
        co-organised by <OrgLink name={"Ys"} /> and <OrgLink name={"Hans"} />. The Arts Resource Hub
        supports Arts Self-Employed Persons and freelance practitioners in Singapore to unlock new
        opportunities and grow meaningful careers.
      </div>
    </>
  );
}
